import { IKeyTerm } from "@core/apiHooks/useSocialThemes";
import { routeNames } from "@core/routeNames";

export const CHAIN_SOCIAL_HASH = '#social';

export function getKeyTermLink({ name, chainId }: IKeyTerm): string {
    if (chainId) {
        return `${routeNames.chainDetails}?id=${encodeURIComponent(chainId)}${CHAIN_SOCIAL_HASH}`;
    }

    return `${routeNames.food}?q=${encodeURIComponent(name.toUpperCase())}`;
}
